import { createBrowserHistory, History } from 'history';
import { setCurrentRoute } from 'src/features/_shared/store/sharedSlices';
import { store } from '../store/configure';
import { Paths } from '../routes';
// import { Paths } from '@routes';
// import { store } from '@store/configure';
// import { setCurrentRoute } from '@features/_shared/store/sharedSlices';

export interface IState {
    id?: string | number;
}

export interface INavigationManager {
    getHistory(): History<unknown> | null;
    getCurrentRoute(): string | undefined;
    navigateTo(path: string, state?: unknown): void;
    replace(path: string): void;
}

export class NavigationManager implements INavigationManager {
    private static instance: NavigationManager;

    private history: History<unknown> = createBrowserHistory({
        basename: process.env.REACT_APP_ROUTER_BASEHREF,
    });

    public static getInstance() {
        if (NavigationManager.instance == null) {
            NavigationManager.instance = new NavigationManager();
        }
        return NavigationManager.instance;
    }

    getHistory() {
        return this.history as History<unknown>;
    }

    navigateTo(path: Paths, state?: IState) {
        this.history?.push(path, state);
        store.dispatch(setCurrentRoute(path));
    }

    replace(path: Paths, state?: IState) {
        this.history?.replace(path, state);
    }

    getCurrentRoute() {
        return this.history?.location.pathname;
    }
}
